var _excluded = ["_tooltip", "_popoverProps", "forwardedRef", "_popTo", "_eventType", "onOutsideClick", "fieldName", "trackTooltipClick", "_usePortal", "_portalContainer", "hideBg"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useEffect, useRef, useState } from 'react';
import { PopoverV3 } from '../PopoverV3';
export function withTooltip(Component) {
  var WithTooltip = function WithTooltip(_ref) {
    var _popoverProps$isOpen;

    var _tooltip = _ref._tooltip,
        _popoverProps = _ref._popoverProps,
        forwardedRef = _ref.forwardedRef,
        _ref$_popTo = _ref._popTo,
        _popTo = _ref$_popTo === void 0 ? 'top' : _ref$_popTo,
        _ref$_eventType = _ref._eventType,
        _eventType = _ref$_eventType === void 0 ? 'click' : _ref$_eventType,
        onOutsideClick = _ref.onOutsideClick,
        fieldName = _ref.fieldName,
        trackTooltipClick = _ref.trackTooltipClick,
        _ref$_usePortal = _ref._usePortal,
        _usePortal = _ref$_usePortal === void 0 ? true : _ref$_usePortal,
        _portalContainer = _ref._portalContainer,
        hideBg = _ref.hideBg,
        ogProps = _objectWithoutProperties(_ref, _excluded);

    var ref = useRef(null);

    var _useState = useState((_popoverProps$isOpen = _popoverProps === null || _popoverProps === void 0 ? void 0 : _popoverProps.isOpen) !== null && _popoverProps$isOpen !== void 0 ? _popoverProps$isOpen : false),
        _useState2 = _slicedToArray(_useState, 2),
        _show = _useState2[0],
        setShow = _useState2[1];

    var handleClick = useCallback(function () {
      if (_eventType === 'click') {
        setShow(function (prevState) {
          return !prevState;
        });
      }
    }, [_eventType]);
    var handleMouseEnter = useCallback(function () {
      if (_eventType === 'hover') {
        setShow(true);
      }
    }, [_eventType]);
    var handleMouseLeave = useCallback(function () {
      if (_eventType === 'hover') {
        setShow(false);
      }
    }, [_eventType]);
    var handleKeyDown = useCallback(function (event) {
      if (_eventType === 'click' && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        setShow(function (prevState) {
          return !prevState;
        });
      }
    }, [_eventType]);
    useEffect(function () {
      var element = ref.current;
      if (!element) return;

      if (_eventType === 'hover') {
        element.addEventListener('mouseenter', handleMouseEnter);
        element.addEventListener('mouseleave', handleMouseLeave);
      }

      if (_eventType === 'click') {
        element.addEventListener('click', handleClick);
        element.addEventListener('keydown', handleKeyDown);
        element.setAttribute('tabindex', '0');
        element.setAttribute('role', 'button');
        element.setAttribute('aria-expanded', _show ? 'true' : 'false');

        if (_tooltip) {
          var tooltipId = "tooltip-".concat(Math.random().toString(36).substr(2, 9));
          element.setAttribute('aria-describedby', tooltipId);
          element.setAttribute('aria-label', 'Show more information');
        }
      }

      return function () {
        if (_eventType === 'hover') {
          element.removeEventListener('mouseenter', handleMouseEnter);
          element.removeEventListener('mouseleave', handleMouseLeave);
        }

        if (_eventType === 'click') {
          element.removeEventListener('click', handleClick);
          element.removeEventListener('keydown', handleKeyDown);
        }
      };
    }, [_eventType, handleClick, handleMouseEnter, handleMouseLeave, handleKeyDown, _show, _tooltip]);
    var refs = useCallback(function (r) {
      ref.current = r;

      if (forwardedRef) {
        if (typeof forwardedRef === 'function') {
          forwardedRef(r);
        } else {
          forwardedRef.current = r;
        }
      }
    }, [forwardedRef]);
    useEffect(function () {
      if (_show && trackTooltipClick && fieldName) {
        trackTooltipClick(fieldName);
      }
    }, [_show, trackTooltipClick, fieldName]);
    useEffect(function () {
      var element = ref.current;

      if (element && _eventType === 'click') {
        element.setAttribute('aria-expanded', _show ? 'true' : 'false');
      }
    }, [_show, _eventType]);
    var handleClose = useCallback(function () {
      setShow(false);

      if (onOutsideClick) {
        onOutsideClick();
      }
    }, [onOutsideClick]);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Component, _extends({
      ref: refs
    }, ogProps)), ref.current && /*#__PURE__*/React.createElement(PopoverV3, _extends({
      position: _popTo,
      isOpen: _show,
      content: _tooltip,
      onClose: handleClose,
      eventType: _eventType,
      usePortal: _usePortal,
      portalContainer: _portalContainer
    }, _popoverProps, {
      attachTo: ref.current,
      hideBg: hideBg
    })));
  };

  return /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(WithTooltip, _extends({}, props, {
      forwardedRef: ref
    }));
  });
}
export default withTooltip;